export default "__VITE_ASSET__edc278eb__"